import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2D2D33",
  d: "M0 12.037c0 6.627 5.373 12 12 12s12-5.372 12-12c0-6.627-5.373-12-12-12s-12 5.373-12 12Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M6.075 11.818a526.013 526.013 0 0 1 6.444-2.775c3.069-1.277 3.706-1.498 4.122-1.506.091-.001.296.021.428.129.112.09.143.213.157.299.015.086.033.282.019.435-.167 1.747-.886 5.987-1.252 7.944-.155.828-.46 1.106-.755 1.133-.642.06-1.13-.424-1.75-.832-.973-.637-1.523-1.034-2.467-1.656-1.09-.719-.384-1.114.238-1.76.163-.169 2.99-2.74 3.045-2.974.007-.029.013-.138-.052-.195-.064-.057-.16-.038-.228-.022-.098.022-1.651 1.049-4.661 3.08-.441.303-.84.45-1.198.443-.395-.008-1.154-.223-1.718-.406-.692-.225-1.242-.344-1.194-.726.025-.2.299-.403.822-.61Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }